<template>
    <div ref="root">
        <div class="collapsible" v-show="title" data-collapsible>
            <div class="collapsible__trigger collapsible__trigger--active" data-collapsible-trigger>
                {{ title }}
            </div>
            <div class="collapsible__content collapsible__content--active" data-collapsible-content>
                <div class="form__group">
                    <!--    radio buttons-->
                    <SearchableRadioList v-if="type=='radio'"/>
                    <SearchableList v-else/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";

import SearchableRadioList from "./SearchableRadioList";
import SearchableList from "./SearchableList";

export default {
    name: "Searchable",
    components: {
        SearchableRadioList,
        SearchableList
    },
    setup() {
        const store = useStore()
        const root = ref('');
        const title = computed(() => store.getters.data?.copy?.label_search_in)
        /**
         *  Type of list to show
         * @values radio,list
         */
        const type = ref('list')

        onMounted(() => {
            // trigger initDom to get the collapsable functionalit
            window.initDom(root.value);
        })

        return {
            type,
            root,
            title,
        }
    }
}
</script>